import { gql } from "@apollo/client";

export const GET_PERSONAL_API_KEYS_LEGACY = gql`
  query GetPersonalApiKeysLegacy {
    viewer {
      apiKeys {
        id
        createdAt
        description
        admin
        teams
        type
        teamCount
        lastUsedAt
        expiresAt
        creator
        name
        spaceCount
        accessRules {
          space
          spaceAccessLevel
        }
        oidcSettings {
          clientId
          issuer
          subjectExpression
        }
      }
    }
    seats {
      apiKey {
        limit
        inUse
      }
    }
  }
`;
